import styled from 'styled-components';

//----------------------------------------------------------------------
// CONNECTED TOKEN LIST
//----------------------------------------------------------------------
export const TokenGroup = styled.div`
	margin: -6px 0 12px 28px;
	padding: 10px 0 0 20px;
	border-left: 2px solid ${(p) => p.theme.gray[200]};
`;

export const TokenList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;

export const TokenRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 12px 16px;
	background: ${(p) => p.theme.gray[0]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 8px;
`;

export const TokenInfo = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 2px;
	min-width: 0;
`;

export const TokenName = styled.div`
	font-size: 14px;
	font-weight: 600;
	color: ${(p) => p.theme.gray[1000]};
`;

export const TokenMeta = styled.div`
	font-size: 12px;
	color: ${(p) => p.theme.gray[700]};
	font-family: 'SF Mono', Menlo, Monaco, Consolas, monospace;
`;

export const RevokeButton = styled.button`
	height: 30px;
	padding: 0 12px;
	background: ${(p) => p.theme.gray[0]};
	color: ${(p) => p.theme.red[700]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 6px;
	font-size: 12px;
	font-weight: 500;
	font-family: inherit;
	transition: all 0.2s ease-in-out;

	&:hover {
		background: ${(p) => p.theme.gray[100]};
		border-color: ${(p) => p.theme.red[500]};
	}
`;

//----------------------------------------------------------------------
// MODAL BODY
//----------------------------------------------------------------------
export const Body = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin: 0 0 20px;
`;

export const FieldLabel = styled.label`
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
	letter-spacing: 0.04em;
	color: ${(p) => p.theme.gray[700]};
	margin-bottom: -10px;
`;

const arrowIcon = (hex: string) => {
	const stroke = hex.replace('#', '%23');
	return `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'><path d='M2.5 4.5l3.5 3.5 3.5-3.5' stroke='${stroke}' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/></svg>")`;
};

export const Select = styled.select`
	height: 40px;
	padding: 0 40px 0 12px;
	background: ${(p) => p.theme.gray[0]} ${(p) => arrowIcon(p.theme.gray[700])} no-repeat right 14px
		center;
	color: ${(p) => p.theme.gray[1000]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 8px;
	font-size: 14px;
	font-family: inherit;
	appearance: none;
	-webkit-appearance: none;

	&:focus {
		outline: none;
		border-color: ${(p) => p.theme.blue[600]};
	}
`;

export const Input = styled.input`
	height: 40px;
	padding: 0 12px;
	background: ${(p) => p.theme.gray[0]};
	color: ${(p) => p.theme.gray[1000]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 8px;
	font-size: 14px;
	font-family: inherit;

	&:focus {
		outline: none;
		border-color: ${(p) => p.theme.blue[600]};
	}
`;

export const Instruction = styled.p`
	font-size: 13px;
	color: ${(p) => p.theme.gray[800]};
	margin: 0;
	line-height: 1.5;
`;

//----------------------------------------------------------------------
// SNIPPET WITH INLINE COPY
//----------------------------------------------------------------------
export const SnippetWrap = styled.div`
	position: relative;
`;

export const Snippet = styled.pre`
	background: ${(p) => p.theme.gray[100]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 8px;
	padding: 14px 64px 14px 16px;
	font-family: 'SF Mono', Menlo, Monaco, Consolas, monospace;
	font-size: 12px;
	color: ${(p) => p.theme.gray[1000]};
	white-space: pre-wrap;
	word-break: break-all;
	margin: 0;
	max-height: 220px;
	overflow-y: auto;
`;

export const CopyInside = styled.button`
	position: absolute;
	top: 8px;
	right: 8px;
	height: 26px;
	padding: 0 10px;
	background: ${(p) => p.theme.gray[0]};
	color: ${(p) => p.theme.gray[800]};
	border: 1px solid ${(p) => p.theme.gray[200]};
	border-radius: 6px;
	font-size: 11px;
	font-weight: 600;
	font-family: inherit;
	transition: all 0.15s ease-in-out;

	&:hover {
		background: ${(p) => p.theme.gray[100]};
		color: ${(p) => p.theme.gray[1000]};
		border-color: ${(p) => p.theme.gray[400]};
	}
`;

export const Disclosure = styled.details`
	font-size: 13px;

	& > summary {
		color: ${(p) => p.theme.blue[600]};
		font-weight: 500;
		list-style: none;
		padding: 4px 0;
		user-select: none;

		&::-webkit-details-marker {
			display: none;
		}

		&:hover {
			color: ${(p) => p.theme.blue[700]};
		}
	}

	&[open] > summary {
		margin-bottom: 12px;
	}
`;

export const DisclosureBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const Warning = styled.div`
	font-size: 12px;
	color: ${(p) => p.theme.orange[700]};
	background: ${(p) => p.theme.orange[50]};
	border: 1px solid ${(p) => p.theme.orange[200]};
	border-radius: 6px;
	padding: 10px 12px;
`;
